import LoginModal from '../LoginModal/LoginModal';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserRound } from 'lucide-react';

const ProfileHeader = () => {
    const isAuthenticated = useSelector((state) => state.service.isAuthenticated);
    const [isOpen, setIsOpen] = useState(false);

    if (isAuthenticated) return <a className="mg-header-top-actions__link cursor-pointer" href="/account" aria-label="Личный кабинет"><UserRound aria-hidden="true" /></a>;

    return <><button type="button" className="mg-header-top-actions__link cursor-pointer" onClick={() => setIsOpen(true)} aria-label="Войти"><UserRound aria-hidden="true" /></button><LoginModal isOpen={isOpen} setIsOpen={setIsOpen} /></>;
};

export default ProfileHeader;
